module.exports = __webpack_public_path__ + "img/miniloto2.61eac05b.png";